const apiVersionV1Path = 'v1';

const pagesetsApiEndpointBaseUrl = `${apiVersionV1Path}/pagesets`;

const articlesApiEndpointBaseUrl = `${apiVersionV1Path}/articles`;

const defaultSnippetRendererUrl = `http://pruse-snippets-staging.azurewebsites.net/${apiVersionV1Path}`;

const disableRetryParam = { disableRetry: true };

// Send structured bodies (incl. arrays / arrays of objects) as JSON. The form-urlencoded
// default cannot represent nested arrays-of-objects; the backend binds JSON identically. See PBI 173831.
const jsonBodyParam = { ...disableRetryParam, contentType: 'application/json' };

export { apiVersionV1Path, articlesApiEndpointBaseUrl, defaultSnippetRendererUrl, disableRetryParam, jsonBodyParam, pagesetsApiEndpointBaseUrl };
